function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(-7.000000, -6.000000)",
  fill: "#D40000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Merlin2525_Paid_Business_Stamp_1",
  fillRule: "nonzero",
  stroke: "#FFFFFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.55708,
  strokeWidth: 0.62742586
}, /*#__PURE__*/React.createElement("g", {
  id: "g3666",
  transform: "translate(157.128240, 155.577155) rotate(-44.454874) translate(-157.128240, -155.577155) translate(13.128240, 79.077155)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4662876,0.299431501 C7.35576261,0.299431501 0.826350837,6.82884328 0.826350837,14.9393682 L0.826350837,138.040322 C0.826350837,146.150847 7.35576261,152.680259 15.4662876,152.680259 L273.03506,152.680259 C281.145585,152.680259 287.674997,146.150847 287.674997,138.040322 L287.674997,14.9393682 C287.674997,6.82884328 281.145585,0.299431501 273.03506,0.299431501 L15.4662876,0.299431501 Z M20.792924,6.50833324 L267.705914,6.50833324 C274.657792,6.50833324 280.254431,12.1049719 280.254431,19.0568504 L280.254431,133.95944 C280.254431,140.911318 274.657792,146.507957 267.705914,146.507957 L20.792924,146.507957 C13.8410454,146.507957 8.24440677,140.911318 8.24440677,133.95944 L8.24440677,19.0568504 C8.24440677,12.1049719 13.8410454,6.50833324 20.792924,6.50833324 Z",
  id: "path3040"
}))), /*#__PURE__*/React.createElement("text", {
  id: "VERIFICATION-FAILED",
  transform: "translate(161.000000, 156.000000) rotate(-45.000000) translate(-161.000000, -156.000000) ",
  fontFamily: "Roboto-Black, Roboto",
  fontSize: 33,
  fontWeight: 700,
  letterSpacing: 3.3
}, /*#__PURE__*/React.createElement("tspan", {
  x: 34.2964355,
  y: 148
}, "VERIFICATION"), /*#__PURE__*/React.createElement("tspan", {
  x: 97.7086426,
  y: 187
}, "FAILED"))));

var SvgVerificationFailedStamp = function SvgVerificationFailedStamp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "301px",
    height: "299px",
    viewBox: "0 0 301 299",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVerificationFailedStamp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/VerificationFailedStamp.a7cfa495.svg";
export { ForwardRef as ReactComponent };